import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import {
  EModFontWeight,
  EModTextAlign,
  IModFontWeight,
  IModTextAlign,
} from '@ucheba/utils/helpers/styles/mod.types'

const Block = styled.td<StyledProps<IModTextAlign & IModFontWeight>>`
  border-bottom: 1px solid ${sv.color.gray5};

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }

  ${Object.keys(EModTextAlign).map(
    (item) => sm.mod(EModTextAlign[item])`
      text-align: ${item};
    `
  )};

  ${Object.keys(EModFontWeight).map(
    (item) => sm.mod(EModFontWeight[item])`
      font-weight: ${sv.fontWeight[item]};
    `
  )};

  padding-left: 0 !important;
`

export default { Block }
